import Cookies from 'js-cookie'
import _ from 'lodash'

export const setCookie = (name, value, time = 365) => {
  if (value) {
    Cookies.set(name, value, { expires: time, path: '/' })
  }
}

export const getCookie = (name) => {
  return Cookies.get(name)
}

export const removeCookie = (name) => {
  return Cookies.remove(name)
}

export const removeAllCookie = () => {
  const cookies = Cookies.get()
  _.keys(cookies).forEach(key => {
    Cookies.remove(key)
  })
}